import moment from 'moment'

export const dataFormatter = (v) => (moment(v).isValid() ? moment(v).format('YYYY-MM-DD') : null)
export const dataParser = (v) => moment(v).format('YYYY-MM-DD')
